import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-top-left-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", d: "m5.5 5.5 7 7" }),
        React.createElement("path", { fill: "currentColor", strokeLinejoin: "round", d: "M4.5 4.5v4l4-4z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
